import { Divider, Form } from 'antd';
import ButtonsToGenerateReports from '@/components/Reports/ButtonsToGenerateReports';
import { DefaultRouteTabs } from '@/components/_common';
import { PageProps } from '@/types/PageProps';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import useFileLoading, { FileType } from '@/hooks/useFileLoading';
import useReportGenerate, { ReportCallback } from '@/hooks/useReportGenerate';
import { DateTimeFormat } from '@/utils/moment';
import MovementUpcomingRevisionsForm from '@/components/Reports/MovementReports/MovementUpcomingRevisionsForm';
import {
  FutureServicesMovementForm,
  FutureServicesMovementRequest,
} from '@/core/domain/reports/movements/futureServices/futureServices.types';
import { useFutureServicesMovementReport } from '@/core/domain/reports/movements/futureServices/futureServices.hooks';

export default function MovementFutureServicesPage({ route }: PageProps) {
  const intl = useIntl();
  const [form] = Form.useForm<FutureServicesMovementForm>();

  const { setFileLoading, setFileUnloading, fileLoading } = useFileLoading();
  const report = useReportGenerate();

  const generateReport = useFutureServicesMovementReport();

  const handleGenerateReport = async (
    format: FileType,
    callback?: ReportCallback,
  ) => {
    setFileLoading(format);

    try {
      const { companiesIds, initialDate, finalDate } =
        await form.validateFields();

      const obj: FutureServicesMovementRequest = {
        format: 'PDF',
        companiesIds: companiesIds?.toString(),
        initialDate: initialDate.format(DateTimeFormat),
        finalDate: finalDate.format(DateTimeFormat),
      };

      const result = await generateReport.mutateAsync(obj);

      if (callback) {
        callback(result);
      }
    } catch {}

    setFileUnloading(format);
  };

  const handleView = () => {
    handleGenerateReport('REPORT_VIEW', (result) =>
      report.openFile({
        result,
        fileName: 'relatorio_proximas_revisoes.pdf',
        fileType: 'application/pdf',
      }),
    );
  };

  const handlePdf = () => {
    handleGenerateReport('PDF', (result) =>
      report.downloadFile({
        result,
        fileName: 'relatorio_proximas_revisoes.pdf',
      }),
    );
  };

  return (
    <DefaultRouteTabs route={route.parent} permissions={route.permissions}>
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <MovementUpcomingRevisionsForm form={form} />

      <Divider />

      <ButtonsToGenerateReports
        viewReport={handleView}
        generatePdf={handlePdf}
        loading={fileLoading}
      />
    </DefaultRouteTabs>
  );
}
